import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { getReviewable, postPicture } from '../../api/orderHistory'
import { getReviewDetail, postProductReviews, putProductReviews } from '../../api/product'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useAppContext } from '../../components/provider/AppProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'

type ImageFileType = {
  id: string
  imgUrl: string | null
}

// 이미지 경로
const imgURL = '/images'

export default function ReviewWrite() {
  const { isAppView } = useAppContext()
  const params = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const rawReviewNo = queryParams.get('reviewNo') ?? location.state?.reviewNo
  const reviewNo = rawReviewNo === 'null' || rawReviewNo === 'undefined' ? null : rawReviewNo
  const productNo = String(params.id || queryParams.get('productNo') || location.state?.productNo)
  const orderNo = String(queryParams.get('orderNo') ? queryParams.get('orderNo') : location.state?.orderNo)
  const path = Number(queryParams.get('path')) || location.state?.path
  const productName = Number(queryParams.get('productName')) || location.state?.productName
  const rawOptionValue = (location.hash || queryParams.get('optionValue')) ?? location.state?.optionValue
  const optionValue = rawOptionValue === 'null' || rawOptionValue === 'undefined' ? null : rawOptionValue

  const [item, setItem] = useState<any>()
  const [rating, setRating] = useState<number>(0)
  const [content, setContent] = useState<string>('')
  const [imageFile, setImageFile] = useState<ImageFileType[]>([
    { id: 'img_file0', imgUrl: null },
    { id: 'img_file1', imgUrl: null },
    { id: 'img_file2', imgUrl: null },
  ])
  const [ratingCount, setRatingCount] = useState<string | number>('')
  const [fileName, setFileName] = useState<string[]>([])

  const isSameOrderAndOption = (el: any, orderNo: string, optionValue: string | null) => {
    const isOrderMatch = String(el.orderNo) === String(orderNo)
    const isOptionMatch = optionValue === null || String(el.optionValue) === String(optionValue)
    if (!isOptionMatch) return isOrderMatch && String(el.productNo) === params.id
    return isOrderMatch && isOptionMatch
  }

  useEffect(() => {
    const fetchReviewable = async () => {
      try {
        const res = await getReviewable()
        const found = res.data.items.find((el: any) => isSameOrderAndOption(el, orderNo, optionValue)) || {}
        setItem(found)
        setRating(0)
        setContent('')
        setRatingCount(0)
        setImageFile([
          { id: 'img_file0', imgUrl: null },
          { id: 'img_file1', imgUrl: null },
          { id: 'img_file2', imgUrl: null },
        ])
      } catch (err) {
        console.log(err)
      }
    }

    const fetchReviewDetail = async () => {
      try {
        const res = await getReviewDetail(productNo || 0, reviewNo)
        setItem(res.data)
        setContent(res.data.content)
        setRatingCount(res.data.rate * 2)
        const array = imageFile.map((img, i) => ({
          ...img,
          imgUrl: res.data.fileUrls[i] || null,
        }))
        setFileName(res.data.fileUrls)
        setImageFile(array)
        setRating(res.data.rate)
      } catch (err) {
        console.log(err)
      }
    }

    if (reviewNo === null || reviewNo === 'null' || reviewNo === undefined || reviewNo === 'undefined') {
      fetchReviewable()
    } else if (reviewNo !== null) {
      fetchReviewDetail()
    }
  }, [])

  const drawStar = (count: any) => {
    const spanElement = document.querySelector('.star span') as HTMLElement

    if (spanElement) {
      spanElement.style.width = `${parseInt(count) * 10}%`
    }
  }

  useEffect(() => {
    // 하단 fixed 버튼이 있으면 푸터 패딩 조정
    const footer = document.querySelector('.footer_wrap') as HTMLElement | null
    if (!footer) return

    footer.style.paddingBottom = isMobile ? '36px' : '0'

    // 언마운트 시 패딩 원복
    return () => {
      footer.style.paddingBottom = ''
    }
  }, [])

  useEffect(() => {
    drawStar(ratingCount)
  }, [ratingCount])

  useEffect(() => {
    const array: string[] = []
    imageFile.map((el: any) => {
      if (el.imgUrl !== null) {
        array.push(el.imgUrl)
      }
      setFileName(array)
    })
  }, [imageFile])

  function uploadFile(e: any, idx: number) {
    if (!e.target.files) {
      return
    }
    const pictureSize = e.target.files[0].size
    const maxSize = 5 * 1024 * 1024
    if (pictureSize > maxSize) {
      alert('첨부할 수 있는 이미지 파일은 5MB이하입니다.')
      return
    }
    const formData = new FormData()
    formData.append('file', e.target.files[0])
    const copy = [...imageFile]
    postPicture(formData)
      .then((res) => {
        copy[idx].imgUrl = res.data.imageUrl
        setImageFile(copy)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  function deletePicture(idx: number) {
    const copy = [...imageFile]
    copy[idx].imgUrl = null
    setImageFile(copy)
  }

  function submitReview() {
    const array: any = []
    imageFile.map((el: any) => {
      if (el.imgUrl !== null) {
        array.push(el.imgUrl)
      }
    })

    postProductReviews(params.id || '', item.optionNo, item.orderOptionNo, content, rating, array)
      .then(() => {
        if (isAppView) {
          RNPostMessage(AFWebLinkType.goBack)
        } else {
          navigate(`/reviewlist/written`)
        }
      })
      .catch((err) => console.log(err))
  }
  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap sidemenu_wrap' : 'contents_wrap sidemenu_wrap full'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <div className='myshopping_contents'>
              <PageTitle>
                상품 리뷰
                {reviewNo === null || reviewNo === undefined ? '작성' : '수정'}
              </PageTitle>

              <div className='review_write'>
                <div className='review_before_box'>
                  <div
                    onClick={() => {
                      if (isAppView) {
                        RNPostMessage(AFWebLinkType.moveToLink, {
                          url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${item?.productNo}`,
                        })
                      } else {
                        navigate(`/product/${item?.productNo}`)
                      }
                    }}
                    className='review_before_item'
                  >
                    <div className='img_box'>
                      <div className='dim'></div>
                      <img
                        src={`${imgURL}/product_bg.png`}
                        style={{
                          backgroundImage: `url(${item?.imageUrl})`,
                        }}
                      />
                    </div>

                    <div className='txt_box'>
                      {item?.brandName && <p className='brand'>{item?.brandName}</p>}
                      <p className='tit'>{item?.productName}</p>
                      <p className='option'>옵션: {!reviewNo ? item?.optionValue : item?.orderedOption?.optionValue}</p>
                      <p className='date'>
                        {!reviewNo
                          ? `${item?.orderStatusDate?.registerYmdt
                              ?.split(' ', 1)
                              .join('')
                              .replaceAll('-', '. ')
                              .replaceAll('. 0', '. ')} 구매함`
                          : `${item?.registerYmdt
                              ?.split(' ', 1)
                              .join('')
                              .replaceAll('-', '. ')
                              .replaceAll('. 0', '. ')} 등록함`}
                      </p>
                    </div>
                  </div>
                </div>
                <div className='star_rating_wrap'>
                  <strong>상품은 어떠셨나요?</strong>
                  <p>별점을 남겨주세요.</p>
                  <div className='star_rating'>
                    <div className='star'>
                      <img src={`${imgURL}/icon_star_off.png`} alt='' />
                      <img src={`${imgURL}/icon_star_off.png`} alt='' />
                      <img src={`${imgURL}/icon_star_off.png`} alt='' />
                      <img src={`${imgURL}/icon_star_off.png`} alt='' />
                      <img src={`${imgURL}/icon_star_off.png`} alt='' />
                      <span>
                        <img src={`${imgURL}/icon_star_on.png`} alt='' />
                        <img src={`${imgURL}/icon_star_on.png`} alt='' />
                        <img src={`${imgURL}/icon_star_on.png`} alt='' />
                        <img src={`${imgURL}/icon_star_on.png`} alt='' />
                        <img src={`${imgURL}/icon_star_on.png`} alt='' />
                      </span>
                      <input
                        type='range'
                        onChange={(e) => {
                          setRatingCount(e.target.value)
                          setRating(Number(e.target.value) * 0.5)
                        }}
                        step='1'
                        min='0'
                        max='10'
                      />
                    </div>
                  </div>
                </div>
                <div className='review_write_box'>
                  <strong>상품에 대한 후기를 작성해주세요.</strong>
                  <div className='sub_text'>
                    <p>
                      텍스트 후기 - 적립금 500
                      <img src={`${imgURL}/icon_point.png`} alt='won' style={{ width: '14px' }} />
                    </p>

                    <p>
                      포토 후기- 적립금 1,000
                      <img src={`${imgURL}/icon_point.png`} alt='won' style={{ width: '14px' }} />
                    </p>
                  </div>

                  <TextAreaWrap>
                    <textarea
                      name=''
                      id=''
                      placeholder='최소 10자 이상 작성해주세요.'
                      value={content}
                      onChange={(e) => {
                        setContent(e.target.value)
                      }}
                    />
                    <div className='filewrap'>
                      <ul>
                        {imageFile.map((el: any, idx: number) => {
                          return (
                            <li key={idx}>
                              <input
                                type='file'
                                name='img_file1'
                                id={`img_file${idx}`}
                                accept='image/*'
                                onChange={(e) => {
                                  uploadFile(e, idx)
                                }}
                              />
                              <label
                                htmlFor={`img_file${idx}`}
                                id={`label_file${idx}`}
                                style={{
                                  border: el.imgUrl ? 'none' : '1px dashed var(--colGray4)',
                                  backgroundImage: el.imgUrl ? `url(${el.imgUrl})` : 'none',
                                  backgroundColor: el.imgUrl ? 'none' : 'var(--colGray1)',
                                  backgroundSize: 'cover',
                                  backgroundRepeat: 'no-repeat',
                                  boxShadow: el.imgUrl ? '0px 0px 0px 1px rgba(0, 0, 0, 0.05)' : 'none',
                                }}
                              >
                                {/* <img
                              src={el.imgUrl}
                              style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: '8px',
                                display: el.imgUrl ? 'block' : 'none',
                              }}
                            ></img> */}
                                <span
                                  style={{
                                    display: el.imgUrl ? 'none' : 'block',
                                  }}
                                ></span>
                              </label>
                              {el.imgUrl ? (
                                <button
                                  type='button'
                                  id='button-delete-1'
                                  onClick={() => {
                                    deletePicture(idx)
                                  }}
                                ></button>
                              ) : null}
                            </li>
                          )
                        })}
                      </ul>
                      <p className='file_notice'>사진은 5MB 이내, 3개까지 첨부 가능합니다.</p>
                    </div>
                    <div className='button_wrap'>
                      <div
                        className='cancel_btn'
                        onClick={() => {
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.goBack)
                          } else {
                            if (path) {
                              navigate(`${path}`)
                            } else {
                              navigate(`/reviewlist/written`)
                            }
                          }
                        }}
                      >
                        취소
                      </div>
                      <button
                        className='submit_btn'
                        onClick={() => {
                          if (content === '' || content.length < 10) {
                            alert('리뷰는 최소 10자 이상 입력 해주세요.')
                            return
                          }

                          if (!reviewNo) {
                            submitReview()
                          } else {
                            if (path) {
                              putProductReviews(productNo || '', reviewNo, content, rating, fileName).then(() => {
                                const review: DataLayerArgs = {
                                  dataLayer: {
                                    event: 'write_review',
                                    event_info: {
                                      item_id: productNo,
                                      item_name: productName,
                                      review_star_rating: rating,
                                    },
                                  },
                                }
                                if (isAppView) {
                                  sendSetAppsflyerEvent({
                                    eventName: 'write_review',
                                    eventType: {
                                      item_id: productNo,
                                      item_name: productName,
                                      review_star_rating: rating,
                                    },
                                  })
                                } else {
                                  TagManager.dataLayer(review)
                                }
                                if (isAppView) {
                                  RNPostMessage(AFWebLinkType.moveToLink, {
                                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}${path}`,
                                  })
                                } else {
                                  navigate(`${path}`)
                                }
                              })
                            } else {
                              putProductReviews(productNo || '', reviewNo, content, rating, fileName).then(() => {
                                const review: DataLayerArgs = {
                                  dataLayer: {
                                    event: 'write_review',
                                    event_info: {
                                      item_id: String(productNo),
                                      item_name: productName,
                                      review_star_rating: rating,
                                    },
                                  },
                                }
                                if (isAppView) {
                                  sendSetAppsflyerEvent({
                                    eventName: 'write_review',
                                    eventType: {
                                      item_id: String(productNo),
                                      item_name: productName,
                                      review_star_rating: rating,
                                    },
                                  })
                                } else {
                                  TagManager.dataLayer(review)
                                }
                                if (isAppView) {
                                  RNPostMessage(AFWebLinkType.goBack)
                                } else {
                                  navigate(`/reviewlist/written`)
                                }
                              })
                            }
                          }
                        }}
                      >
                        등록
                      </button>
                    </div>
                  </TextAreaWrap>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export const TextAreaWrap = styled.div`
  margin-top: 16px;
  & textarea {
    width: 100%;
    height: 208px;
    padding: 8px 16px;
    border: 1px solid var(--colGray3);
    border-radius: 5px;
    color: var(--colBlack);
    font-size: 14px;
    line-height: 20px;
    &:focus {
      border: 1px solid var(--colBlack);
    }
  }
  & .filewrap {
    margin-top: 16px;
    & ul {
      display: flex;
      gap: 10px;
      & li {
        position: relative;
        & input {
          padding: 0;
          font-size: 0;
          line-height: inherit;
          color: transparent;
          letter-spacing: 0;
          width: 0 !important;
          display: none;
        }
        & label {
          position: relative;
          display: block;
          width: 80px;
          height: 80px;
          border: 1px dashed var(--colGray4);
          background: var(--colGray1);
          border-radius: 8px;
          & div {
          }
          & span {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 24px;
            height: 24px;
            background: url('../images/icon_plus24.svg') no-repeat;
            background-size: contain;
          }
        }
        & button {
          position: absolute;
          top: 0;
          right: 0;
          padding: 0;
          border: 0;
          width: 32px;
          height: 32px;
          background: url('../images/icon_clear_button.png') no-repeat;
          background-size: contain;
        }
      }
    }
    & p.file_notice {
      margin-top: 12px;
      color: var(--colGray5);
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
    }
  }
  & .button_wrap {
    margin-top: 24px;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    text-align: center;
    & .cancel_btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 48px;
      font-size: 14px;
      line-height: 24px;
      color: var(--colBlack);
      border: 1px solid var(--colGray3);
      border-radius: 5px;
    }
    & .submit_btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 48px;
      font-size: 14px;
      line-height: 24px;
      color: var(--colWhite);
      background: var(--colBlack);
      border: 0;
      border-radius: 5px;
    }
  }
  @media screen and (min-width: 768px) {
    & textarea {
      width: 100%;
      height: 208px;
      padding: 14px 16px;
      border: 1px solid var(--colGray3);
      border-radius: 5px;
      color: var(--colBlack);
      font-size: 15px;
      font-weight: 500;
      line-height: 20px;
    }
    & .filewrap {
      margin-top: 16px;
      & ul {
        display: flex;
        gap: 10px;
        & li {
          position: relative;
          & input {
            padding: 0;
            font-size: 0;
            line-height: inherit;
            color: transparent;
            letter-spacing: 0;
            width: 0 !important;
            display: none;
          }
          & label {
            position: relative;
            display: block;
            width: 100px;
            height: 100px;
            border: 1px dashed var(--colGray4);
            background: var(--colGray1);
            border-radius: 8px;
            & div {
            }
            & span {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 24px;
              height: 24px;
              background: url('../images/icon_plus24.svg') no-repeat;
              background-size: contain;
            }
          }
          & button {
            position: absolute;
            top: 0;
            right: 0;
            padding: 0;
            border: 0;
            width: 32px;
            height: 32px;
            background: url('../images/icon_clear_button.png') no-repeat;
            background-size: contain;
          }
        }
      }
      & p.file_notice {
        margin-top: 12px;
        color: var(--colGray5);
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
      }
    }
    & .button_wrap {
      margin-top: 24px;
      display: flex;
      gap: 8px;
      justify-content: space-between;
      text-align: center;
      & .cancel_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 56px;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: var(--colBlack);
        border: 1px solid var(--colGray3);
        border-radius: 5px;
      }
      & .submit_btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 56px;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: var(--colWhite);
        background: var(--colBlack);
        border: 0;
        border-radius: 5px;
      }
    }
  }
`
